import axios from 'axios'
import { API_URL } from '../../../../constants'
import { ApiResponse } from '../../../common/api/response.types'
import { MatchingDecision, PayoutMatchingHistory, TicketCard } from './response.types'

export const TICKET_CARD_URL = `${API_URL}/api/internal/ticket`

export const getTicketCard = (token: string) =>
  axios.get<ApiResponse<TicketCard>>(`${TICKET_CARD_URL}/${token}`)

export const getMatchingDecision = (token: string) =>
  axios.get<ApiResponse<MatchingDecision>>(`${TICKET_CARD_URL}/${token}/matching-decision`)

export const getPayoutMatchingHistory = (token: string) =>
  axios.get<ApiResponse<PayoutMatchingHistory>>(`${TICKET_CARD_URL}/${token}/matching-history`)
